/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react'

import { BlockProformaType } from '@customTypes/proforma'

import Input from '@components/shared/input'
import NumberFormat from '@components/shared/Number'
import { MeasuredUnit } from '@constants/rawMaterial'

import { ListFormatter, periodString } from './string'

type BlockResumenParams = {
  index?: number
  reduced?: boolean
  block: BlockProformaType
  userRole: string
  handleInput?: (path: string, value: number | string) => void
}

export const getBlockResumen = (params: BlockResumenParams) => {
  const { block, reduced, index, handleInput, userRole } = params

  const { receipts } = block

  if (reduced) {
    return periodString(
      `La oferta incluye: ${ListFormatter.format(receipts.map(({ name }) => name))}`,
    )
  }

  const hasReceipts = receipts.length > 0

  return (
    <React.Fragment>
      {hasReceipts && (
        <ol>
          {receipts.map((receipt, idxReceipt) => (
            <li key={receipt.uid}>
              {receipt.name}
              <ul>
                {receipt.rawMaterials.map((material, idxRm) => {
                  if (reduced) {
                    return (
                      <li key={material.uid}>
                        {material.name} {material.quantity} {MeasuredUnit[material.measure].value}
                      </li>
                    )
                  }

                  return (
                    <li className="cd-my-[0.75rem]" key={material.uid}>
                      {material.name}: {material.quantity} {MeasuredUnit[material.measure].value}
                      {handleInput && (
                        <Input
                          defaultValue={material.value}
                          disabled={userRole !== 'admin'}
                          display={userRole !== 'admin' ? 'none' : 'block'}
                          min={0}
                          prefix="$"
                          readOnly={userRole !== 'admin'}
                          typeInput="number"
                          variant="default"
                          onChange={(value) =>
                            handleInput(
                              `items.${index}.receipts.${idxReceipt}.rawMaterials.${idxRm}.value`,
                              value,
                            )
                          }
                        />
                      )}
                      {!handleInput && <span>. Valor: </span>}
                      {!handleInput && <NumberFormat value={material.value} />}
                    </li>
                  )
                })}
              </ul>
            </li>
          ))}
        </ol>
      )}
      {!hasReceipts && handleInput && (
        <Input
          defaultValue={block.value ?? 0}
          disabled={userRole !== 'admin'}
          display={userRole !== 'admin' ? 'none' : 'block'}
          min={0}
          prefix="$"
          readOnly={userRole !== 'admin'}
          typeInput="number"
          variant="default"
          onChange={(value) => handleInput(`items.${index}.value`, value)}
        />
      )}
    </React.Fragment>
  )
}
